export const config ={
    apiUrl:"https://app.mayashop.ovh/api/",
    apiAuth:"https://app.mayashop.ovh/api/auth.php",
    url_picture:"https://app.mayashop.ovh/files/uploads/"
};